import UploadImage from '@/components/upload-image/index.vue';
import { mapGetters } from 'vuex';
import CollectivePurchasingService from '../collective-purchasing-service';
import PurchaseBusinessService from '../../person-center/purchase-business/purchase-business-service';
import Service from '@/service/index.js';
import { errorMessage, successMessage } from '@/utils/message.js';
import SelectBank from '@/components/select-bank/index.vue';
const debounce = require('lodash.debounce');

export default {
  components: {
    UploadImage,
    SelectBank
  },
  computed: {
    ...mapGetters([
      'loginUserType',
      'userInfo',
      'getTenantParams'
    ])
  },
  data () {
    return {
      projectName: '',
      ruleForm: {
        economicMemberName: '',
        remark: '',
        files: [],
        bankId: ''
      },
      submitStatus: 'init',
      action: '/api/v1.0/chanquan/fast/uploadFile',
      headers: {},
      promiseEnterprise: '',
      criminalRecord: '',
      qualificationReview: '',
      purchaseType: '',
      filedata: {},
      filedatasuccess: false,
      rules: {
        bankId: [
          { required: true, message: '请选择银行账号', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '输入供应数量', trigger: 'blur' }
          // { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      },
      projectInfo: {},
      remarkTitle: '请输入备注信息',
      gridData: [{
        date: '10以下',
        name: '2'
      }, {
        date: '10（不含）～100',
        name: '1.5'
      }, {
        date: '100（不含）～1000',
        name: '1'
      }, {
        date: '1000（不含）以上',
        name: '0.5'
      }],
      fileList: []
    };
  },
  created () {
    this.id = this.$route.query.id;
    this.purchaseType = this.$route.query.purchaseType;
    this.promiseEnterprise = this.$route.query.promiseEnterprise;
    this.criminalRecord = this.$route.query.criminalRecord;
    this.qualificationReview = this.$route.query.qualificationReview;
    if (this.$route.query.relationId) {
      this.getPurchaseSignupDetail();
    } else if (this.id) {
      this.getPurchaseProjectDetail();
    }
    Service.getSelectList('SIGN_PEOPLE_BID_FILE_TYPE').then(res => {
      if (res && res.code === '0') {
        const arr = res.data.sort((a, b) => a.sort - b.sort).slice(0, 3);
        this.initFile(arr, res.data);
      }
    });
    const tId = this.getTenantParams.tId; // 租户id,跟区域相关
    if (tId) {
      this.headers['TENANT-ID'] = tId;
    }
  },
  methods: {
    // 初始化文件列表
    initFile (arr, brr) {
      console.log(arr, brr);
      arr.forEach(item => {
        // 授权委托书
        if (item.code === '1') {
          item.value = '法人单位的授权委托书';
        }
        this.ruleForm.files.push({
          projectFileType: Number(item.code),
          title: item.value,
          filePaths: [],
          inputValue: null
        });
      });
      // 一般招标、依法必招 不展示
      if (!([4, 5].includes(Number(this.purchaseType)))) {
        this.ruleForm.files.splice(1, 0, {
          projectFileType: brr[5] && Number(brr[5].code),
          title: brr[5] && brr[5].value,
          filePaths: [],
          description: brr[5] && brr[5].description,
          inputValue: null,
          defaultImage: []
        });
        // 犯罪记录类型
        if ((Number(this.criminalRecord) === 1)) {
          this.ruleForm.files.splice(2, 0, {
            projectFileType: brr[6] && Number(brr[6].code),
            title: brr[6] && brr[6].value,
            filePaths: [],
            description: brr[6] && brr[6].description,
            inputValue: null,
            defaultImage: []
          });
        } else {
          this.ruleForm.files.splice(2, 0, {
            projectFileType: brr[7] && Number(brr[7].code),
            title: brr[7] && brr[7].value,
            filePaths: [],
            description: brr[7] && brr[7].description,
            inputValue: null,
            defaultImage: []
          });
        }
        //  失信企业名单类型
        if (Number(this.promiseEnterprise) === 1) {
          this.ruleForm.files.splice(3, 0, {
            projectFileType: brr[8] && Number(brr[8].code),
            title: brr[8] && brr[8].value,
            filePaths: [],
            description: brr[8] && brr[8].description,
            inputValue: null,
            defaultImage: []
          });
        } else {
          this.ruleForm.files.splice(3, 0, {
            projectFileType: brr[9] && Number(brr[9].code),
            title: brr[9] && brr[9].value,
            filePaths: [],
            description: brr[9] && brr[9].description,
            inputValue: null,
            defaultImage: []
          });
        }
      } else {
        // 删除资格证明材料
        this.ruleForm.files.splice(1, 1);
      }
      // if (this.loginUserType !== 1) {
      //   this.ruleForm.files.splice(2, 0, {
      //     projectFileType: brr[6] && Number(brr[6].code),
      //     title: brr[6] && brr[6].value,
      //     filePaths: [],
      //     description: brr[6] && brr[6].description,
      //     inputValue: null
      //   });
      // }
      if (this.loginUserType === 1 || this.loginUserType === 3) {
        this.ruleForm.files.splice(0, 1);
      }
    },
    // 必填校验
    fileRules (item) {
      let required = true;
      console.log(this.loginUserType, 'loginUserType');
      if (item.projectFileType === 1 && (this.loginUserType === 1 || this.loginUserType === 3)) {
        required = false;
      }
      if (item.projectFileType === 3) {
        required = false;
      }
      // if (item.projectFileType === 8 && this.loginUserType === 1) {
      //   required = false;
      // }
      return {
        required: required,
        message: '请上传' + item.title,
        trigger: 'change'
      };
    },
    // 文件上传成功
    handleUpSuccess (response, file, fileList) {
      // this.filedata = fileList[0].response.data;
      // this.ruleForm.files[0].urls[0] = this.filedata.fullPath;
      let index = this.ruleForm.files.findIndex(item => item.projectFileType === 5);
      let fileInfo = {
        filePaths: [fileList[0].response.data.fullPath],
        projectFileType: 5,
        fileName: fileList[0].name
      };
      if (index >= 0) {
        this.ruleForm.files[index] = fileInfo;
      } else {
        this.ruleForm.files.push(fileInfo);
      }
      // this.ruleForm.files.push({
      //   filePaths: [fileList[0].response.data.fullPath],
      //   projectFileType: 5,
      //   fileName: fileList[0].name
      // });
      console.log(this.ruleForm.files, '-----sssssss');
      this.filedatasuccess = true;
    },
    handleUpRemove () {
      this.filedata = {};
      let index = this.ruleForm.files.findIndex(item => item.projectFileType === 5);
      // 清空已经上传的文件
      if (index >= 0) {
        this.ruleForm.files.splice(index, 1);
      }
      this.filedatasuccess = false;
    },
    beforeUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      const extension = testmsg === 'xls';
      const extension2 = testmsg === 'xlsx';
      const extension3 = testmsg === 'doc';
      const extension4 = testmsg === 'docx';
      const extension5 = testmsg === 'pdf';
      const isLt2M = file.size / 1024 / 1024;
      console.log(file);
      if (!extension && !extension2 && !extension3 && !extension4 && !extension5) {
        this.$message({
          message: '上传文件只能是 doc、docx、pdf、xls、xlsx格式!',
          type: 'error',
          duration: 1000,
          offset: 327
        });
      }
      if (isLt2M > 50) {
        this.$message({
          message: '上传文件大小不能超过 50MB!',
          type: 'error',
          duration: 1000,
          offset: 327
        });
      }
      return (extension || extension2 || extension3 || extension4 || extension5) && isLt2M;
    },
    // 获取采购详情
    getPurchaseProjectDetail () {
      CollectivePurchasingService.getPurchaseProjectDetail({
        purchaseId: this.id,
        echoCode: 'PURCHASE'
      }).then(res => {
        if (res && res.code === '0') {
          this.projectName = res && res.data && res.data.projectName;
          this.purchaseType = res?.data?.purchaseType;
          this.projectInfo = res.data;
        }
      });
    },
    // 撤销报名回显
    getPurchaseSignupDetail () {
      PurchaseBusinessService.getSignUpPurchaseDetail(this.$route.query.relationId).then(({ code, data }) => {
        if (code === '0') {
          this.projectName = data?.signInfo?.projectName;
          this.purchaseType = data?.purchaseType;
          this.projectInfo = { ...data.signInfo, purchaseType: data.purchaseType, goodsType: data.goodsType };

          // this.promiseEnterprise = data.promiseEnterprise;
          // this.criminalRecord = data.criminalRecord;
          // this.qualificationReview = data.qualificationReview;

          this.ruleForm.remark = data?.signInfo.remark;
          this.ruleForm.bankId = data?.signInfo.bankId;
          let resFiles = data?.fileInfos;

          resFiles.forEach(item => {
            // 响应文件
            if (item.projectFileType === 5) {
              let fileName = '';
              item.filePaths.forEach(image => {
                this.fileList.push({
                  name: image.fileName,
                  url: image.allPath
                });
                fileName = image.fileName;
              });
              this.ruleForm.files.push({
                fileName: fileName,
                filePaths: item.filePaths.map(subItem => subItem.fullPath),
                projectFileType: item.projectFileType
              });
              this.filedatasuccess = true;
            }

            const index = this.ruleForm.files.findIndex(file => file.projectFileType === item.projectFileType);
            if (index >= 0 && item.projectFileType !== 5) {
              this.ruleForm.files[index].defaultImage = [];
              item.filePaths.forEach(image => {
                this.ruleForm.files[index].defaultImage.push({
                  url: image.allPath,
                  ossImgUrl: image.allPath,
                  sourceImgUrl: image.fullPath
                });
                this.ruleForm.files[index].filePaths.push({
                  ossImgUrl: image.allPath,
                  sourceImgUrl: image.fullPath
                });
                this.ruleForm.files[index].inputValue = this.ruleForm.files[index].filePaths.length;
              });
            }
          });

          console.log(this.ruleForm, '====响应文件');
        }
      });
    },
    // 上传图片
    uploadImage (index, event) {
      this.ruleForm.files[index].filePaths = event;
      if (event.length) {
        this.ruleForm.files[index].inputValue = event.length;
      } else {
        this.ruleForm.files[index].inputValue = null;
      }
    },
    // 返回上一步
    previousStep () {
      this.$router.back();
    },
    // 提交报名
    test: debounce(function () {
      console.log(this.filedatasuccess, 'this.filedatasuccess');
      // if(!([4, 5].includes(this.purchaseType)) && this.projectInfo.goodsType !== 1 && this.filedatasuccess === false) {
      //   this.$message({
      //     message: '请上传响应（投标）文件',
      //     type: 'warning',
      //     duration: 1000,
      //     offset: 327
      //   });
      // } else {
      if (this.submitStatus === 'ongoing') { return; }
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交报名信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit();
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
      // }
    }, 2000, {
      'leading': true,
      'trailing': false
    }),
    // 跳转授权委托书样例
    downTemplate () {
      window.open('/授权委托书样例（法人机构用户）.pdf');
    },
    // 跳转承诺书样例
    downTemplated () {
      window.open('/承诺书样例.pdf');
    },
    submit () {
      const files = [];
      // console.log(this.ruleForm.files, 'this.ruleForm.files');
      this.ruleForm.files.forEach(item => {
        const filePaths = [];
        item.filePaths.forEach(obj => {
          if (obj.sourceImgUrl) {
            filePaths.push(obj.sourceImgUrl);
          } else {
            filePaths.push(obj);
          }
        });
        if (item.fileName) {
          files.push({
            imgEnumType: item.projectFileType,
            urls: [...filePaths],
            fileName: item.fileName
          });
        } else {
          files.push({
            imgEnumType: item.projectFileType,
            urls: [...filePaths]
          });
        }
      });
      console.log(files, 'filesfiles');
      this.submitStatus = 'ongoing';
      CollectivePurchasingService.purchaseProjectSignUp({
        ...this.ruleForm,
        files: files,
        purchaseId: this.id
      }).then(res => {
        if (res && res.code === '0') {
          this.submitStatus = 'success';
          successMessage('报名成功');
          this.$router.push('/person-center/purchase-business/sign-up-purchase/list');
        } else if (res && res.reason) {
          this.submitStatus = 'failed';
          errorMessage(res && res.reason);
        } else {
          this.submitStatus = 'failed';
          errorMessage('报名失败');
        }
      }, (error) => {
        this.submitStatus = 'failed';
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('报名失败');
        }
      });
    }
  }
};
